import React, { FC, useCallback } from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import BulkTransferSLButton from '../assets_overview_page/BulkTransferSLButton';
import OverviewShell from '../overview_shell/OverviewShell';

const style = require('./StockLocationsOverviewPage.less');

const StockLocationsOverviewPage: FC<any> = ({ history, childRoutes }): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/supplier/stockLocations/overview/${key}`),
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{
			key: 'all',
			name: 'All',
		},
	];

	return (
		<>
			<Route
				path="/supplier/stockLocations/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/supplier/stockLocations/overview/all',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Stock Locations"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="stockLocationsPage"
				headerRightContent={<BulkTransferSLButton />}
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StockLocationsOverviewPage));
